/** `/c/$companyId/settings/default-accounts` — the default accounts; anyone with access reads them. */
import type { JSX } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { DefaultAccountsScreen } from "../ledger/DefaultAccountsScreen";

export const Route = createFileRoute("/_auth/c/$companyId/settings/default-accounts")({
  component: DefaultAccountsRoute,
});

function DefaultAccountsRoute(): JSX.Element {
  const { companyId } = Route.useParams();
  return <DefaultAccountsScreen companyId={companyId} />;
}
